import React from 'react';
import { CheckCircle } from '@mui/icons-material';
import { Box } from '@mui/material';

const VerifiedTick = ({size = 20}) => {
  return (
    <Box>
      <CheckCircle sx={{ color: 'green', fontSize: size }} />
    </Box>
  );
};

export default VerifiedTick;